import * as React from "react";
const DividerSizeMedium = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 8h-1V6h-2V5h2a1 1 0 0 1 1 1v2ZM8 19H6a1 1 0 0 1-1-1v-2h1v2h2v1ZM5 8h1V6h2V5H6a1 1 0 0 0-1 1v2Zm14 10a1 1 0 0 1-1 1h-2v-1h2v-2h1v2ZM5 11h14v1H5v-1Z" }));
DividerSizeMedium.displayName = "DividerSizeMedium";
var DividerSizeMedium_default = DividerSizeMedium;
export {
  DividerSizeMedium_default as default
};
